module.exports = __webpack_public_path__ + "img/arrow-down-white.726e70eb.svg";